import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e77be3ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "canvas",
  ref: "canvas"
}
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<defs data-v-e77be3ee><filter id=\"category-control\" data-v-e77be3ee><feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"-1 0 0 0 1\n                                                              0 -1 0 0 1\n                                                              0 0 -1 0 1\n                                                              0 0 0 1 0\" data-v-e77be3ee></feColorMatrix></filter><filter id=\"category-action\" data-v-e77be3ee><feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"-1 0 0 0 1\n                                                              0 -1 0 0 1\n                                                              0 0 -1 0 1\n                                                              0 0 0 1 0\" data-v-e77be3ee></feColorMatrix></filter><filter id=\"category-start\" data-v-e77be3ee><feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"-1 0 0 0 1\n                                                              0 -1 0 0 1\n                                                              0 0 -1 0 1\n                                                              0 0 0 1 0\" data-v-e77be3ee></feColorMatrix></filter><filter id=\"category-lookup\" data-v-e77be3ee><feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"-1 0 0 0 1\n                                                              0 -1 0 0 1\n                                                              0 0 -1 0 1\n                                                              0 0 0 1 0\" data-v-e77be3ee></feColorMatrix></filter></defs>", 1)
const _hoisted_4 = ["transform", "transform-origin"]
const _hoisted_5 = ["transform"]
const _hoisted_6 = { class: "connections" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_9 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_10 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_11 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_12 = ["transform"]
const _hoisted_13 = ["x", "width"]
const _hoisted_14 = {
  x: 0,
  y: 0
}
const _hoisted_15 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_16 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_17 = ["transform"]
const _hoisted_18 = ["x", "width"]
const _hoisted_19 = {
  x: 0,
  y: 0
}
const _hoisted_20 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_21 = ["x1", "y1", "x2", "y2", "onMousedown"]
const _hoisted_22 = ["transform"]
const _hoisted_23 = ["x", "width"]
const _hoisted_24 = {
  x: 0,
  y: 0
}
const _hoisted_25 = ["cx", "cy", "onMousedown", "onDblclick"]
const _hoisted_26 = ["d"]
const _hoisted_27 = ["x1", "y1", "x2", "y2"]
const _hoisted_28 = { class: "objects" }
const _hoisted_29 = ["transform", "onDblclick", "onContextmenu", "onClick"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "150",
  y1: "120",
  x2: "150",
  y2: "160",
  class: "add-building-block-line"
}, null, -1))
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "300",
  y1: "60",
  x2: "350",
  y2: "60",
  class: "add-building-block-line"
}, null, -1))
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = ["onMousedown"]
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<rect class=\"box-hover\" data-v-e77be3ee></rect><path class=\"arrow\" d=\"M 150 -15 L 160 -5 L 140 -5 L 150 -15\" data-v-e77be3ee></path><path class=\"arrow\" d=\"M 150 135 L 160 125 L 140 125 L 150 135\" data-v-e77be3ee></path><path class=\"arrow\" d=\"M -15 60 L -5 70 L -5 50 L -15 60\" data-v-e77be3ee></path><path class=\"arrow\" d=\"M 315 60 L 305 70 L 305 50 L 315 60\" data-v-e77be3ee></path>", 5)
const _hoisted_44 = [
  _hoisted_39
]
const _hoisted_45 = ["data-idx", "onMousedown"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", { class: "title-box" }, null, -1))
const _hoisted_47 = {
  class: "title",
  x: "150",
  y: "16"
}
const _hoisted_48 = {
  key: 3,
  class: "status-loading",
  x: "145",
  y: "70"
}
const _hoisted_49 = {
  key: 4,
  class: "status-info",
  x: "90",
  y: "32",
  width: "200",
  height: "80"
}
const _hoisted_50 = {
  xmlns: "http://www.w3.org/1999/xhtml",
  style: {"background-color":"transparent","max-height":"80px","font-size":"80%"}
}
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = ["y"]
const _hoisted_53 = {
  key: 6,
  class: "description",
  x: "150",
  y: "110"
}
const _hoisted_54 = ["href"]
const _hoisted_55 = {
  key: 7,
  transform: "translate(45,76)"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "icon-overlay-circle",
  r: "13",
  cx: "13",
  cy: "13"
}, null, -1))
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", { class: "selectbox" }, null, -1))
const _hoisted_59 = { class: "invalid-label" }
const _hoisted_60 = ["href"]
const _hoisted_61 = { class: "types" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "items" }
const _hoisted_64 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: _ctx.width,
      height: _ctx.height,
      class: _normalizeClass(_ctx.drag.confirmed ? 'dragging' : ''),
      onMousemove: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDragOver($event))),
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDragStop($event))),
      onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onDragStart($event, 'canvas', null)), ["stop","prevent"])),
      onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDragStop($event))),
      onWheel: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.onScroll($event)), ["prevent","stop"]))
    }, [
      _hoisted_3,
      _createElementVNode("g", {
        class: "zoom",
        transform: 'scale(' + _ctx.zoom + ')',
        "transform-origin": _ctx.zoomOriginX + ' ' + _ctx.zoomOriginY
      }, [
        _createElementVNode("g", {
          class: "content",
          transform: 'translate(' + _ctx.panX + ', ' + _ctx.panY + ')'
        }, [
          _createElementVNode("g", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.flow.connections, (connection, idx) => {
              return (_openBlock(), _createElementBlock("g", {
                key: idx,
                class: _normalizeClass(['connection', _ctx.vm.selected === connection ? 'selected' : '']),
                onClick: ($event: any) => (_ctx.vm.selected = connection)
              }, [
                (connection.waypoints && connection.waypoints.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("line", {
                        x1: connection.from.x + 150,
                        y1: connection.from.y + 60,
                        x2: connection.waypoints[0].x,
                        y2: connection.waypoints[0].y,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, 0)), ["stop","prevent"])
                      }, null, 40, _hoisted_8),
                      _createElementVNode("line", {
                        class: "connection-line-overlay",
                        x1: connection.from.x + 150,
                        y1: connection.from.y + 60,
                        x2: connection.waypoints[0].x,
                        y2: connection.waypoints[0].y,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, 0)), ["stop","prevent"])
                      }, null, 40, _hoisted_9),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connection.waypoints, (waypoint, widx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (widx > 0)
                            ? (_openBlock(), _createElementBlock("line", {
                                key: idx + ',' + widx,
                                x1: connection.waypoints[widx - 1].x,
                                y1: connection.waypoints[widx - 1].y,
                                x2: waypoint.x,
                                y2: waypoint.y,
                                onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, widx)), ["stop","prevent"])
                              }, null, 40, _hoisted_10))
                            : _createCommentVNode("", true),
                          (widx > 0)
                            ? (_openBlock(), _createElementBlock("line", {
                                class: "connection-line-overlay",
                                key: idx + ',' + widx + ',overlay',
                                x1: connection.waypoints[widx - 1].x,
                                y1: connection.waypoints[widx - 1].y,
                                x2: waypoint.x,
                                y2: waypoint.y,
                                onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, widx)), ["stop","prevent"])
                              }, null, 40, _hoisted_11))
                            : _createCommentVNode("", true),
                          (connection.type && widx > 0 && Math.floor(connection.waypoints.length / 2) === widx)
                            ? (_openBlock(), _createElementBlock("g", {
                                key: idx + ',' + widx + ',group',
                                transform: 
                                            'translate(' +
                                            (connection.waypoints[widx - 1].x + (waypoint.x - connection.waypoints[widx - 1].x) / 2) +
                                            ', ' +
                                            (connection.waypoints[widx - 1].y + (waypoint.y - connection.waypoints[widx - 1].y) / 2) +
                                            ')'
                                        ,
                                class: "type-box"
                              }, [
                                _createElementVNode("rect", {
                                  x: connection.type.label.length * -2.5 - 10,
                                  width: connection.type.label.length * 5 + 20,
                                  y: "-10",
                                  rx: "5",
                                  ry: "5"
                                }, null, 8, _hoisted_13),
                                _createElementVNode("text", _hoisted_14, _toDisplayString(connection.type.label), 1)
                              ], 8, _hoisted_12))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256)),
                      _createElementVNode("line", {
                        x1: connection.waypoints[connection.waypoints.length - 1].x,
                        y1: connection.waypoints[connection.waypoints.length - 1].y,
                        x2: connection.to.x + 150,
                        y2: connection.to.y + 60,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, connection.waypoints.length)), ["stop","prevent"])
                      }, null, 40, _hoisted_15),
                      _createElementVNode("line", {
                        class: "connection-line-overlay",
                        x1: connection.waypoints[connection.waypoints.length - 1].x,
                        y1: connection.waypoints[connection.waypoints.length - 1].y,
                        x2: connection.to.x + 150,
                        y2: connection.to.y + 60,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, connection.waypoints.length)), ["stop","prevent"])
                      }, null, 40, _hoisted_16),
                      (connection.type && connection.waypoints.length === 1)
                        ? (_openBlock(), _createElementBlock("g", {
                            key: 0,
                            transform: 
                                        'translate(' +
                                        (connection.waypoints[0].x + (connection.from.x + 150 - connection.waypoints[0].x) / 2) +
                                        ', ' +
                                        (connection.waypoints[0].y + (connection.from.y + 60 - connection.waypoints[0].y) / 2) +
                                        ')'
                                    ,
                            class: "type-box"
                          }, [
                            _createElementVNode("rect", {
                              x: connection.type.label.length * -2.5 - 10,
                              width: connection.type.label.length * 5 + 20,
                              y: "-10",
                              rx: "5",
                              ry: "5"
                            }, null, 8, _hoisted_18),
                            _createElementVNode("text", _hoisted_19, _toDisplayString(connection.type.label), 1)
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!connection.waypoints || connection.waypoints.length === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("line", {
                        x1: connection.from.x + 150,
                        y1: connection.from.y + 60,
                        x2: connection.to.x + 150,
                        y2: connection.to.y + 60,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, 0)), ["stop","prevent"])
                      }, null, 40, _hoisted_20),
                      _createElementVNode("line", {
                        class: "connection-line-overlay",
                        x1: connection.from.x + 150,
                        y1: connection.from.y + 60,
                        x2: connection.to.x + 150,
                        y2: connection.to.y + 60,
                        onMousedown: _withModifiers(($event: any) => (_ctx.onConnectionMouseDown($event, idx, 0)), ["stop","prevent"])
                      }, null, 40, _hoisted_21),
                      (connection.type)
                        ? (_openBlock(), _createElementBlock("g", {
                            key: 0,
                            transform: 
                                        'translate(' +
                                        (connection.from.x + (connection.to.x - connection.from.x) / 2 + 150) +
                                        ', ' +
                                        (connection.from.y + (connection.to.y - connection.from.y) / 2 + 60) +
                                        ')'
                                    ,
                            class: "type-box"
                          }, [
                            _createElementVNode("rect", {
                              x: connection.type.label.length * -2.5 - 10,
                              width: connection.type.label.length * 5 + 20,
                              y: "-10",
                              rx: "5",
                              ry: "5"
                            }, null, 8, _hoisted_23),
                            _createElementVNode("text", _hoisted_24, _toDisplayString(connection.type.label), 1)
                          ], 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connection.waypoints, (waypoint, widx) => {
                  return (_openBlock(), _createElementBlock("circle", {
                    key: widx,
                    cx: waypoint.x,
                    cy: waypoint.y,
                    r: "3",
                    onMousedown: _withModifiers(($event: any) => (_ctx.onDragStart($event, 'waypoint', idx * 10000 + widx)), ["stop","prevent"]),
                    onDblclick: ($event: any) => (_ctx.onWaypointDblClick($event, idx, widx))
                  }, null, 40, _hoisted_25))
                }), 128)),
                _createElementVNode("path", {
                  d: 
                                    [
                                        'M',
                                        _ctx.arrowHead(connection).x,
                                        _ctx.arrowHead(connection).y,
                                        'L',
                                        _ctx.arrowHead(connection).x - Math.sin(_ctx.arrowHead(connection).alpha - 0.5) * 20,
                                        _ctx.arrowHead(connection).y - Math.cos(_ctx.arrowHead(connection).alpha - 0.5) * 20,
                                        'L',
                                        _ctx.arrowHead(connection).x - Math.sin(_ctx.arrowHead(connection).alpha + 0.5) * 20,
                                        _ctx.arrowHead(connection).y - Math.cos(_ctx.arrowHead(connection).alpha + 0.5) * 20,
                                        'L',
                                        _ctx.arrowHead(connection).x,
                                        _ctx.arrowHead(connection).y,
                                    ].join(' ')
                                
                }, null, 8, _hoisted_26)
              ], 10, _hoisted_7))
            }), 128))
          ]),
          (_ctx.drag.confirmed && _ctx.drag.type === 'newconnection')
            ? (_openBlock(), _createElementBlock("line", {
                key: 0,
                x1: _ctx.drag.objectX,
                y1: _ctx.drag.objectY,
                x2: _ctx.vm.flow.objects[_ctx.drag.idx].x + 150,
                y2: _ctx.vm.flow.objects[_ctx.drag.idx].y + 60,
                class: "drag-line"
              }, null, 8, _hoisted_27))
            : _createCommentVNode("", true),
          _createElementVNode("g", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.flow.objects, (object, idx) => {
              return (_openBlock(), _createElementBlock("g", {
                key: idx,
                transform: 'translate(' + object.x + ', ' + object.y + ')',
                class: _normalizeClass(['object', object.category, _ctx.vm.selected === object ? 'selected' : '', object.status === false ? 'invalid' : '']),
                onDblclick: ($event: any) => (_ctx.$emit('activate-object', idx)),
                onContextmenu: _withModifiers(($event: any) => (_ctx.showObjectContextMenu($event, object, idx)), ["stop","prevent"]),
                onClick: ($event: any) => (_ctx.vm.selected = object)
              }, [
                (!_ctx.hasConnections(object) && !_ctx.vm.readonly && !_ctx.vm.advanced)
                  ? (_openBlock(), _createElementBlock("g", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("circle", {
                        class: "add-building-block",
                        cx: "150",
                        cy: "160",
                        r: "15",
                        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                        onClick: _withModifiers(($event: any) => (
                                        _ctx.$emit('add-object', {
                                            previousObjectIdx: idx,
                                            previousObject: object,
                                            coords: { x: object.x, y: object.y + 200 },
                                        })
                                    ), ["stop","prevent"])
                      }, null, 40, _hoisted_32),
                      _createElementVNode("text", {
                        class: "add-building-block-icon",
                        x: "150",
                        y: "165",
                        innerHTML: _ctx.overlayText.add
                      }, null, 8, _hoisted_33)
                    ]))
                  : (_ctx.hasOneConnection(object) && !_ctx.vm.readonly && !_ctx.vm.advanced)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("circle", {
                          class: "add-building-block",
                          cx: "350",
                          cy: "60",
                          r: "15",
                          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
                          onClick: _withModifiers(($event: any) => (
                                        _ctx.$emit('add-object', {
                                            previousObjectIdx: idx,
                                            previousObject: object,
                                            coords: { x: object.x + 450, y: object.y },
                                        })
                                    ), ["stop","prevent"])
                        }, null, 40, _hoisted_36),
                        _createElementVNode("text", {
                          class: "add-building-block-icon",
                          x: "350",
                          y: "65",
                          innerHTML: _ctx.overlayText.add
                        }, null, 8, _hoisted_37)
                      ]))
                    : _createCommentVNode("", true),
                (!_ctx.vm.readonly && _ctx.vm.advanced)
                  ? (_openBlock(), _createElementBlock("g", {
                      key: 2,
                      class: "hover",
                      onMousedown: _withModifiers(($event: any) => (_ctx.onDragStart($event, 'newconnection', idx)), ["stop","prevent"])
                    }, _hoisted_44, 40, _hoisted_38))
                  : _createCommentVNode("", true),
                _createElementVNode("rect", {
                  class: "box",
                  "data-idx": idx,
                  onMousedown: _withModifiers(($event: any) => (_ctx.onDragStart($event, 'object', idx)), ["stop","prevent"])
                }, null, 40, _hoisted_45),
                _hoisted_46,
                _createElementVNode("text", _hoisted_47, _toDisplayString(object.description ? object.description : object.title), 1),
                (object.status === null)
                  ? (_openBlock(), _createElementBlock("text", _hoisted_48, "..."))
                  : (object.statusInfo)
                    ? (_openBlock(), _createElementBlock("foreignObject", _hoisted_49, [
                        _createElementVNode("body", _hoisted_50, [
                          _createElementVNode("div", {
                            innerHTML: object.statusInfo
                          }, null, 8, _hoisted_51)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                (object.description && object.description.indexOf('\n') !== -1)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(object.description.split('\n'), (text, lineIdx) => {
                      return (_openBlock(), _createElementBlock("text", {
                        key: lineIdx,
                        class: "description",
                        x: "150",
                        y: 110 + lineIdx * 16
                      }, _toDisplayString(text), 9, _hoisted_52))
                    }), 128))
                  : (_openBlock(), _createElementBlock("text", _hoisted_53, _toDisplayString(object.description ? object.description : 'No description'), 1)),
                _createElementVNode("image", {
                  href: _ctx.vm.getIconUrl(object.icon),
                  class: "darkmode-invert"
                }, null, 8, _hoisted_54),
                (object.subCategory)
                  ? (_openBlock(), _createElementBlock("g", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("text", {
                        class: "icon-overlay",
                        x: "13",
                        y: "17",
                        innerHTML: _ctx.overlayText[object.subCategory]
                      }, null, 8, _hoisted_57)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("circle", {
                  class: _normalizeClass(['category-circle', object.category]),
                  r: "6",
                  cx: "12",
                  cy: "12"
                }, null, 2),
                _hoisted_58,
                _createElementVNode("g", _hoisted_59, [
                  _createElementVNode("image", {
                    class: "invalid",
                    href: _ctx.vm.getWarningIcon()
                  }, null, 8, _hoisted_60)
                ])
              ], 42, _hoisted_29))
            }), 128))
          ])
        ], 8, _hoisted_5)
      ], 8, _hoisted_4)
    ], 42, _hoisted_2)),
    (_ctx.connectionTypeSelector && _ctx.connectionTypeSelector.connection)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "connection-type-overlay",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ((_ctx.connectionTypeSelector.connection.type = _ctx.connectionTypeSelector.types[0]) && (_ctx.connectionTypeSelector.connection = undefined)), ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "connection-type-selector",
            style: _normalizeStyle({
                    left: _ctx.connectionTypeSelector.x + 'px',
                    top: _ctx.connectionTypeSelector.y - _ctx.connectionTypeSelector.types.length * 12.5 + 'px',
                })
          }, [
            _createElementVNode("div", _hoisted_61, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectionTypeSelector.types, (type) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "type",
                  key: type,
                  onClick: _withModifiers(($event: any) => ((_ctx.connectionTypeSelector.connection.type = type) && (_ctx.connectionTypeSelector.connection = undefined)), ["stop"])
                }, _toDisplayString(type.label), 9, _hoisted_62))
              }), 128))
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.contextmenu && _ctx.contextmenu.items && _ctx.contextmenu.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "contextmenu-overlay",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.contextmenu.items = []), ["stop"])),
          onContextmenu: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.contextmenu.items = []), ["stop","prevent"]))
        }, [
          _createElementVNode("div", {
            class: "contextmenu",
            style: _normalizeStyle({ left: _ctx.contextmenu.x + 'px', top: _ctx.contextmenu.y + 'px' })
          }, [
            _createElementVNode("div", _hoisted_63, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contextmenu.items, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: idx,
                  onClick: _withModifiers(($event: any) => ((_ctx.contextmenu.items = []) && item.fn()), ["stop"])
                }, _toDisplayString(item.label), 9, _hoisted_64))
              }), 128))
            ])
          ], 4)
        ], 32))
      : _createCommentVNode("", true)
  ], 512))
}